import useSelectDropdownFilter from '../hooks/useSelectDropdownFilter';
import { Select } from 'antd';

const allFilter = [
  {
    value: 'all',
    label: `Any`
  }
];

const ClientProductFilter = ({ onFilter, title, filters }) => {
  const { onSelectedFilterChanged, selectedFilter } = useSelectDropdownFilter(allFilter, onFilter);

  if (!filters) {
    return null;
  }

  const products = allFilter.concat(
    filters.map((x) => {
      return {
        value: x._id,
        label: `${x.classCount} for ${x.currency} ${x.cost}`
      };
    })
  );

  return (
    <div className="client__product-filter">
      <h4>{title}</h4>
      <Select options={products} value={selectedFilter} onChange={onSelectedFilterChanged} />
    </div>
  );
};

export default ClientProductFilter;
